import './App.css';
import { Flex } from '@adobe/react-spectrum';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation, Outlet, ScrollRestoration } from 'react-router-dom';
import { HeaderBar } from './components/headerBar/HeaderBar';
import { FooterBar } from './components/footerBar/FooterBar';
import { handleUpdatedAppRoute } from './data/redux/slices/appSlice';
import { getAnalytics, logEvent } from 'firebase/analytics';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from 'react-oidc-context';
import useBuyMeACoffee from './hooks/useBuyMeACoffee';

// Page titles excluded from page_view analytics (matched against document.title)
const PAGE_VIEW_BLOCKLIST = [
    'Leaderboard',
    'Authors > undefined',
    'Commanders >',
    'Authors >',
    'Playtest - Loading...',
    'User Details - Loading...',
    'Author Details - Loading...',
    'Commander Details - Loading...',
];

export default function AppBody(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const route = useSelector((state) => state.app.route);
    const dispatch = useDispatch();
    const auth = useAuth();
    const userProfileName = useSelector((state) => state.userDetails?.profile?.metadata?.profileName);

    const prevRoute = useRef(route?.path || '/');

    // Initialize Buy Me a Coffee widget
    // useBuyMeACoffee();

    // Manual page_view logging (automatic tracking is disabled in Firebase config)
    useEffect(() => {
        // Short delay to let react-helmet update document.title before we read it
        const timeout = setTimeout(() => {
            if (!PAGE_VIEW_BLOCKLIST.includes(document.title)) {
                try {
                    logEvent(getAnalytics(), 'page_view', {
                        page_title: document.title,
                        page_location: window.location.href,
                        page_path: location.pathname,
                    });
                } catch (e) {
                    // analytics not initialized yet
                }
            }
        }, 0);
        return () => clearTimeout(timeout);
    }, [location.pathname]);

    if (
        /\/user\/id\/[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}/.test(window.location.href) &&
        userProfileName &&
        userProfileName !== ''
    ) {
        window.history.replaceState({}, null, `/user/id/${userProfileName}`);
    }

    useEffect(() => {
        if (!window.location.href.includes('?code=')) {
            let currentRoute = route?.path;

            if (prevRoute.current !== currentRoute) {
                const uri = window.location.pathname;
                let adoptingUrlAsRoute = false;

                if (!currentRoute && uri !== prevRoute.current) {
                    currentRoute = uri;
                    adoptingUrlAsRoute = true;
                }

                prevRoute.current = currentRoute || '/';

                navigate(currentRoute + (adoptingUrlAsRoute ? window.location.hash : ''));
                dispatch(handleUpdatedAppRoute({ route: currentRoute, firstRouteHandled: false }));
            }
        }
    }, [route]);

    window.addEventListener('popstate', (event) => {
        if (window.location.href !== route.path && !window.location.href.includes('?code=')) {
            const uri = window.location.pathname;

            if (prevRoute.current !== uri) {
                prevRoute.current = uri;
                dispatch(handleUpdatedAppRoute({ route: uri }));
            }
        }
    });

    return (
        // <ScrollRestoration>
        <div style={{ maxWidth: '100vw', overflowX: 'clip' }}>
            <Flex id="AppContainer" direction="column">
                <HeaderBar />
                <Flex id="ContentContainer" direction="row" justifyContent="center">
                    <Flex
                        id="CenterContentContainer"
                        direction="column"
                        marginBottom="85px"
                        maxWidth={2000}
                        width={'100vw'}
                        // width={2000}
                    >
                        <Outlet />
                    </Flex>
                </Flex>
                <FooterBar />
            </Flex>
        </div>
        // </ScrollRestoration>
    );
}
